<template>

	 <!-- :style="{backgroundImage:'url('+require('@/assets/images/shenpi1.png')+')'}" -->

    <div>
        <img class="bg" src="@/assets/images/oa/bg.png" alt="">
        <div class="hello"  :style="'height:'+screenHeight+'px;width:'+screenWidth+'px'" >  
             
            

            <!-- <div> </div> -->
         
            <div class="regisPhone_wrap">
                <!-- <div class="logo_bar" style="margin-bottom:20px;margin-top:40px;"> 
                    <img  src="@/assets/newlogo.png" style="height:75%;width:auto" >
                </div> -->

                <div class="itemBar1" style="margin-top:10px;text-align:center;font-size:20px; border-bottom:1px solid #dedede"> {{isphone_regis? '您已绑定过手机':'绑定手机' }}  </div>
                <div class="itemBar2" style="margin-top:15px">手机号</div>
                <div class="itemBar1"  >  
                    <el-input v-model="form.phone"  placeholder="请输入手机号"  ></el-input>

                </div>
                <div class="itemBar2">手机验证码</div>
                <div class="itemBar1"  >  
                    <el-input v-model="form.code"    placeholder="请输入验证码"  @change="VerifyCode">
                        <!-- <template slot="append">获取短信验证码</template> -->
                        <el-button slot="append" style="height:85%;" :disabled="isphone_regis"  @click="GetCaptcha" >点击获取验证码</el-button>
                    </el-input>

                </div>

                <div class="itemBar2" style="text-align:right;color:red"> {{code_msg}} </div>

                <div class="itemBar1"  style="margin-top:15px;margin-bottom:55px;">  
                    <el-button type="primary"  :disabled="isphone_regis" @click="BindPhone"> 绑定 </el-button> 

                </div>
            
                


            </div>

            <!-- <div class="newboss">
        
                <el-col :span="6" style="margin-left:auto;margin-right:auto;margin-bottom:20px">
                    绑定手机
                </el-col>

            
                <el-form ref="form" :model="form" label-width="80px" style="width:100%">
        
                
                    <el-form-item label="手机号码" v-if="!$store.state.hasPhone">
                        <el-col :span="11">
                            <el-input v-model="form.phone" :disabled="$store.state.isceo || isphone_regis"   ></el-input>
                        </el-col>
                        
                        <el-col :span="8" style="margin-left:15px">
                
                            <el-button :disabled="$store.state.isceo || isphone_regis" @click="GetCaptcha">发送验证码</el-button>
                        </el-col>
                    
                    </el-form-item>
        

                    <el-form-item label="验证码" v-if="!$store.state.hasPhone">
                        <el-col :span="11">
                            <el-input @change="VerifyCode" v-model="form.captcha"  ></el-input>
                        </el-col>

                        <el-col :span="8" style="margin-left:15px">
                    
                            <el-button  type="text"  style="color:red"> {{code_msg}} </el-button>
                        </el-col>
                    
                    </el-form-item>
                

        
                    <el-form-item >
                        <el-button type="primary" @click="onSubmit"  :disabled="$store.state.isceo" style="margin-left:5%;margin-right:20%;width:25%">立即创建</el-button>
                        <el-button  style="width:25%" @click="Back2Home"> 取消</el-button>
                    </el-form-item>
                </el-form>


            


            </div> -->

        

        

        </div>
    </div>
 


</template>

<script>

function guid2() {  //
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4()  + S4()  + S4() +  S4() +  S4() + S4() + S4());
}

export default {
  name: 'regis_phone',
  props: {
    msg: String
  },
  data() {
		return {
	
			screenWidth:window.innerWidth,
			screenHeight:window.innerHeight,
	 
			form: {
		 
				code:'' ,
				_id:'',
			},
			isphone_regis:false,
            code_msg:'',
            isPhone_valid:false,

		}
  },
  created(){
	  this.form.createdate=new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate()

	  let phone=this.$root.accountInfo.phone || null
	  if ( phone && phone.length==11){
		  this.form.phone=phone
		  this.isphone_regis=true
      }
      console.log('isphone_regis:',this.isphone_regis)

  },

  mounted(){
	  if(this.$store.state.isceo){
			this.$notify({
				title: '提示',
				message: '您已经有一个oa应用，不可再创建，有问题请联系官方客服',
				duration: 0
			});

	    }
	 

  },

   methods: {

	//    Turn2main(){
	// 	   this.$router.push({name:'main' }) 


	//    },
		GetCaptcha(){
			let phone=this.form.phone
			// let reg=/\d{11}/
			if(!(/^1[3456789]\d{9}$/.test(phone))){ 
				this.$notify({
					title: '警告',
					message: '手机号码格式有误',
					type: 'warning'
				});
				return
			} 
			var that=this
			let _id=guid2()
			console.log('_id:',_id)
			this.form._id=_id

			var data={
				phonenumber:phone,
				_id:_id,
				whattodo:'get_sms_captcha'
			}


			this.axios.post( this.$root.rootUrl+'lawtip_web_oa',data
            ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
					let result=res.data
					console.log('result:',result)
                    if(result.status=='ok'){
					   that.$notify({
							title: '成功',
							message: '验证码已发送',
							type: 'success'
						});
                        that.code_msg='验证码已发送,五分钟内有效，1分钟内最多申请一次'

                    } else  if(result.status=='fail'){
                        that.$message({
                            message: result.failMsg,
                            type: 'warning',
                            showClose:true,
                            duration:4000,
                          
                        });



                    }

          
     
                }

                
            }).catch(function (error) {
                window.console.log(error);
               
            });



        },
        
 

		VerifyCode(){
			let captcha=this.form.code || ''
			console.log('captcha:',captcha)
			if (captcha){
				let len=captcha.length
				console.log('code:',captcha,'len:',len)
				if (len==4){
					this.verify_code()


				}


			}
			 
		},


		verify_code(){
			var that=this
			var data={
				phonenumber:this.form.phone,
				_id:this.form._id,
				whattodo:'check_sms_captcha',
				code:this.form.code
			}

			this.axios.post('https://api.lawtip.cn/oa',data
            ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
					let result=res.data
					console.log('result:',result)
					if (result.status=='ok'){
						that.code_msg='验证成功，有效期十分钟'
					}else if(result.status=='fail'){
						that.code_msg='验证码错误'

					}

          
     
                }

                
            }).catch(function (error) {
                window.console.log(error);
               
            });

		},

	    BindPhone() {
			console.log('submit!');
			console.log('form:',this.form);
			// if(!this.form || this.form.length<4){
			// 	this.$notify({
			// 		title: '失败',
			// 		message: '名称不可少于4个字哦',
			// 		type: 'error'
			// 	});
            // }
            let phone=this.form.phone
			 
			if(!(/^1[3456789]\d{9}$/.test(phone))){ 
				this.$notify({
					title: '警告',
					message: '手机号码格式有误',
					type: 'warning'
				});
				return
			} 
			var data=this.form
			data.whattodo='bind_phone'
			var that=this
 
       

            this.axios.post( this.$root.rootUrl+ 'lawtip_web_oa',data
            ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
					let result=res.data
					console.log('result:',result)
                    if(result.status=='ok'){
             
						that.$notify({
							title: '成功',
							message: '绑定成功，建议刷新下页面',
							type: 'success'
                        });
                        
                        let a=that.$store.state.accountInfo
                        a.phone=that.form.phone

                        that.$root.accountInfo=a
                        that.$store.commit('ChangeAccountInfo',a)


					 	that.$router.push({path:"/"})
						// that.$router.push({name:'structure'})

                    }else if(result.status=='fail'){
                        // that.$message.error(result.failMsg);
                        that.$message({
                            message: result.failMsg,
                            type: 'warning',
                            showClose:true,
                            duration:4000,
                          
                        });

					}

          
     
                }
              
            
                
            }).catch(function (error) {
                // window.console.log(error);
                that.$message({
                    message: '服务器出错，请联系客服' ,
                    type: 'error',
                    showClose:true,
                    duration:4000,
                    
                });
               
            });









		},



		Back2Home(){

			this.$router.push({name:"workbench"})
		}




   },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.newboss{
	padding: 15px 10px;
 
	min-height: 400px;
	min-width:40%;
	border:1px solid rgb(191, 192, 185);
	position: fixed;
    top:10%;
	left:30%;
	/* margin-left:auto;
	margin-right:auto; */
	z-index: 999;

	display: flex;
	flex-direction: column;
 
	align-items: center;
	border-radius: 15px;
	background-color: rgba(255, 255, 255, 0.5);

	/* justify-content: space-between; */
	 
}
.login_box img{
	width:35px;
	height: 29px;
	margin:auto;
}

.login_box .row{
	display: flex;
	flex-direction: row;
	width: 100%;
}

 

.bg{
	/* width:100%;
	height: 100%; */
	/* opacity: 0.7; */
	/* object-fit: cover; */
	
	/* object-fit: contain; */
	max-width: 100%;
    height: auto;
	width:100%;
}

 

 



 

.buttonline{
	width:70%;
	display: flex;
	flex-direction: row;
}
 
</style>

<style scoped>
    .hello{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items:flex-end;
        position: fixed;
        top:0;
        /* right: 10vh; */
        
    }
    .regisPhone_wrap{
        display: flex;
        flex-direction: column;
        /* border:1px solid rgb(226, 145, 38); */

        width:400px;
        /* min-height: 600px; */
        /* margin-left: auto;
        margin-right: auto; */
        background-color: #fff;
        border-radius: 2%;
        /* margin-top:15vh; */
        margin-right: 10vh;
       /* opacity: 0.8; */
       margin-bottom: 10vh;
         


    }
    
    .logo_bar{
        /* width:600px; */
        height: 120px;
        /* border:1px solid rgb(27, 199, 56); */
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        

    }

    .itemBar1{
        width:85%;
        height: 50px;
        /* border:1px solid rgb(67, 26, 216); */
        /* margin-left: auto;
        margin-right: auto; */
        margin:4px auto;
        line-height: 50px;
      
        
    }
    .itemBar1 .el-button {
        width:100%;
    }
    .itemBar2{
        width:85%;
        height: 30px;
        line-height: 30px;
        /* border:1px solid rgb(27, 199, 56); */
        margin:1px auto; 
        /* margin-left: auto;
        margin-right: auto; */
        font-weight: 100;
        font-size: 14px;
        
    }
 

</style>